import * as React from 'react';
import { connect } from 'react-redux';
import { Dropdown } from 'semantic-ui-react';

// Actions
import { updateQueryString } from 'services/router/actions';

// Components
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';

interface Props {
    timesheetEntryUuid: number;
    updateQueryString: Function;
}

export class TimesheetEntrySplitDropdownItem extends React.PureComponent<Props> {
    handleClick = (event: SyntheticInputEvent<EventTarget>) => {
        const { timesheetEntryUuid } = this.props;

        this.props.updateQueryString({
            timesheetEntrySplitModal: true,
            selectedTimesheetEntry: timesheetEntryUuid
        });
    };

    render() {
        return (
            <CurrentSeasonInProgressGate>
                <Dropdown.Item text="Split" onClick={this.handleClick} />
            </CurrentSeasonInProgressGate>
        );
    }
}

export default connect(
    null,
    { updateQueryString }
)(TimesheetEntrySplitDropdownItem);
